export class UserDetailModel {
    constructor(NameKjLs, NameKjFs, NameKnLs, NameKnFs, MailAddress, Birthday, Gender, Lang, PhoneNumber, UserKeyNo) {
        this.NameKjLs = NameKjLs;
        this.NameKjFs = NameKjFs;
        this.NameKnLs = NameKnLs;
        this.NameKnFs = NameKnFs;
        this.MailAddress = MailAddress;
        this.Birthday = Birthday;
        this.Gender = Gender;
        this.Lang = Lang;
        this.PhoneNumber = PhoneNumber;
        this.UserKeyNo = UserKeyNo;
    }
}
